module.exports = __webpack_public_path__ + "img/img4.d33cbd08.svg";